import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface PricingOption {
  id: string;
  emoji: string;
  title: string;
  description: string;
  originalPrice: string;
  price: string;
  ctaText: string;
  ctaHref: string;
  isFeatured?: boolean;
  savings?: string;
  discountBadge?: string;
  discountPercent?: string;
}
const options: PricingOption[] = [{
  id: 'megapack',
  emoji: '📘',
  title: 'MEGAPACK FÚTBOL LISTO',
  description: '6 Tomos + 6 Bonos completos',
  originalPrice: '$55,90',
  price: '$13,90',
  ctaText: 'SÍ, QUIERO MI MEGAPACK AHORA →',
  ctaHref: 'https://docentes2.edulabs.online/cart/43285137457270:1',
  discountBadge: 'USD',
  discountPercent: '-75%'
}, {
  id: 'elite',
  emoji: '🏆',
  title: 'MEGAPACK + ACADEMIA ÉLITE 360',
  description: 'Todo el Megapack + el sistema completo de gestión y escala: Modelo de negocio · Finanzas · Captación · Retención · Expansión',
  originalPrice: '$79,90',
  price: '$19,90',
  ctaText: 'SÍ, QUIERO EL PACK COMPLETO AHORA →',
  ctaHref: 'https://docentes2.edulabs.online/cart/43285137490038:1',
  isFeatured: true,
  savings: 'AHORRÁS $60',
  discountBadge: 'USD',
  discountPercent: '-75%'
}];
export function PricingSection() {
  const [selected, setSelected] = useState('elite');
  const selectedOption = options.find(o => o.id === selected)!;
  return <section id="pricing" className="w-full bg-[#111111] py-12 sm:py-24 px-4 overflow-visible" data-id="element-182">
      <div className="max-w-xl mx-auto relative" data-id="element-183">
        {/* Subtle background glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#22C55E]/5 rounded-full blur-[100px] pointer-events-none" data-id="element-184" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5
      }} className="relative z-10" data-id="element-185">
          <h2 className="text-2xl sm:text-4xl font-black text-white text-center mb-1.5 sm:mb-3" data-id="element-186">
            Elegí tu{' '}
            <span className="text-[#22C55E]" data-id="element-187">Megapack Fútbol Listo:</span>
          </h2>
          <p className="text-gray-400 text-center text-xs sm:text-base mb-6 sm:mb-12" data-id="element-188">
            Ambas opciones incluyen los 6 tomos y los 6 bonos completos
          </p>

          <div className="space-y-4 sm:space-y-5 mb-6 sm:mb-10" data-id="element-189">
            {options.map(option => {
            const isSelected = selected === option.id;
            const isFeatured = option.isFeatured;
            return <motion.button key={option.id} onClick={() => setSelected(option.id)} className={`relative w-full text-left rounded-2xl p-4 sm:p-6 transition-all duration-300 ${isSelected ? isFeatured ? 'bg-[#052e16] border-2 border-[#22C55E] shadow-[0_0_40px_rgba(34,197,94,0.15)]' : 'bg-[#1a1a1a] border-2 border-white/40 shadow-lg' : 'bg-[#141414] border-2 border-white/5 hover:border-white/20 hover:bg-[#1a1a1a]'}`} whileHover={{
              scale: isSelected ? 1 : 1.01
            }} whileTap={{
              scale: 0.99
            }} data-id="element-190">
                  {/* Featured Ribbon */}
                  {isFeatured && <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gradient-to-r from-[#22C55E] to-[#16A34A] text-black text-[10px] sm:text-xs font-black px-3 sm:px-4 py-0.5 sm:py-1 rounded-full shadow-lg border border-[#4ADE80]/50 whitespace-nowrap z-20" data-id="element-191">
                      ⭐ MÁS ELEGIDO
                    </div>}

                  {/* Featured Glow Outline */}
                  {isFeatured && isSelected && <motion.div className="absolute inset-0 rounded-2xl border-2 border-[#22C55E] pointer-events-none" animate={{
                opacity: [0.5, 1, 0.5]
              }} transition={{
                duration: 2,
                repeat: Infinity,
                ease: 'easeInOut'
              }} data-id="element-192" />}

                  <div className="relative z-10" data-id="element-193">
                    {/* Top row: radio + title + description */}
                    <div className="flex items-start gap-3 sm:gap-4" data-id="element-194">
                      {/* Radio Circle */}
                      <div className="mt-1 sm:mt-0.5 relative flex items-center justify-center w-5 h-5 sm:w-6 sm:h-6 rounded-full border-2 flex-shrink-0 transition-colors duration-300" data-id="element-195">
                        <div className={`absolute inset-0 rounded-full border-2 transition-colors duration-300 ${isSelected ? isFeatured ? 'border-[#22C55E]' : 'border-white' : 'border-white/20'}`} data-id="element-196" />
                        <AnimatePresence data-id="element-197">
                          {isSelected && <motion.div initial={{
                        scale: 0
                      }} animate={{
                        scale: 1
                      }} exit={{
                        scale: 0
                      }} transition={{
                        type: 'spring',
                        stiffness: 500,
                        damping: 30
                      }} className={`w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full ${isFeatured ? 'bg-[#22C55E]' : 'bg-white'}`} data-id="element-198" />}
                        </AnimatePresence>
                      </div>

                      <div className="flex-1 min-w-0" data-id="element-199">
                        <div className="flex items-center gap-1.5 sm:gap-2 mb-1 flex-wrap" data-id="element-200">
                          <span className="text-base sm:text-xl" data-id="element-201">
                            {option.emoji}
                          </span>
                          <span className="text-white font-black text-sm sm:text-lg leading-tight" data-id="element-202">
                            {option.title}
                          </span>
                        </div>

                        <p className="text-gray-400 text-[11px] sm:text-sm leading-snug sm:leading-relaxed" data-id="element-203">
                          {option.description}
                        </p>
                      </div>
                    </div>

                    {/* Price row — separated for clarity */}
                    <div className="mt-3 sm:mt-4 ml-8 sm:ml-10 flex items-center gap-3 flex-wrap" data-id="element-204">
                      <div className="flex items-baseline gap-2" data-id="element-205">
                        <span className={`font-black text-2xl sm:text-4xl tracking-tight ${isFeatured ? 'text-[#22C55E]' : 'text-white'}`} data-id="element-206">
                          {option.price}
                        </span>
                        <span className="text-gray-500 text-xs sm:text-sm font-medium uppercase" data-id="element-207">
                          {option.discountBadge}
                        </span>
                      </div>
                      <div className="flex items-center gap-2" data-id="element-208">
                        <span className="text-gray-500 line-through text-xs sm:text-sm font-medium" data-id="element-209">
                          {option.originalPrice}
                        </span>
                        <span className="bg-red-500/15 text-red-400 text-[10px] sm:text-xs font-black px-1.5 sm:px-2 py-0.5 rounded-md" data-id="element-210">
                          {option.discountPercent}
                        </span>
                      </div>
                      {isFeatured && option.savings && <span className="bg-[#22C55E]/10 text-[#22C55E] text-[10px] sm:text-xs font-bold px-2 sm:px-2.5 py-0.5 sm:py-1 rounded-md border border-[#22C55E]/20" data-id="element-211">
                          {option.savings}
                        </span>}
                    </div>
                  </div>
                </motion.button>;
          })}
          </div>

          {/* Social Proof Line */}
          <div className="flex items-center justify-center gap-2 mb-4 sm:mb-5" data-id="element-212">
            <span className="relative flex h-2 w-2" data-id="element-213">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-214" />
              <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500" data-id="element-215" />
            </span>
            <p className="text-gray-300 text-xs sm:text-sm font-medium" data-id="element-216">
              <strong className="text-white" data-id="element-217">+200 entrenadores</strong>{' '}
              eligieron esta opción esta semana
            </p>
          </div>

          {/* CTA Button */}
          <motion.a href={selectedOption.ctaHref} className="btn-green-pulse green-shimmer relative block w-full text-center bg-gradient-to-b from-[#2DD264] to-[#1EA94D] text-black font-black text-base sm:text-xl py-5 sm:py-6 rounded-2xl overflow-hidden group" whileHover={{
          scale: 1.03,
          boxShadow: '0 0 60px rgba(34,197,94,0.45), 0 0 120px rgba(34,197,94,0.15)'
        }} whileTap={{
          scale: 0.97
        }} initial={{
          boxShadow: '0 0 40px rgba(34,197,94,0.25), 0 4px 20px rgba(0,0,0,0.3)'
        }} transition={{
          type: 'spring',
          stiffness: 400,
          damping: 25
        }} data-id="element-218">
            {/* Inner highlight edge */}
            <div className="absolute inset-0 rounded-2xl border border-white/20 pointer-events-none" data-id="element-219" />
            {/* Top shine */}
            <div className="absolute inset-x-0 top-0 h-[45%] bg-gradient-to-b from-white/15 to-transparent rounded-t-2xl pointer-events-none" data-id="element-220" />
            {/* Hover sweep */}
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-in-out pointer-events-none" data-id="element-221" />

            <span className="relative z-10 flex items-center justify-center gap-1.5 sm:gap-2" data-id="element-222">
              <span className="drop-shadow-[0_1px_1px_rgba(0,0,0,0.15)]" data-id="element-223">
                {selectedOption.ctaText.replace(' →', '')}
              </span>
              <motion.span className="inline-flex items-center text-base sm:text-xl leading-none -mt-px" animate={{
              x: [0, 5, 0]
            }} transition={{
              duration: 1.2,
              repeat: Infinity,
              ease: 'easeInOut'
            }} data-id="element-224">
                →
              </motion.span>
            </span>
          </motion.a>

          {/* Local Currency Trust Line */}
          <p className="text-gray-300 text-[11px] sm:text-sm font-medium text-center mt-3 sm:mt-4" data-id="element-225">
            <span className="inline-flex items-center align-middle mr-1 text-sm leading-none" data-id="element-226">
              🌎
            </span>
            Pagás en <strong className="text-white" data-id="element-227">tu moneda local</strong> —
            el monto se convierte automáticamente
          </p>

          {/* Description Text */}
          <AnimatePresence mode="wait" data-id="element-228"></AnimatePresence>

          {/* Trust Badges */}
          <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-4 mt-5 sm:mt-10" data-id="element-229">
            {[{
            icon: '🔒',
            text: 'Pago seguro'
          }, {
            icon: '⚡',
            text: 'Acceso en 5 min'
          }, {
            icon: '🛡️',
            text: 'Garantía 7 días'
          }, {
            icon: '💳',
            text: 'Tarjeta · PayPal · Transferencia'
          }].map((badge, i) => <div key={i} className="flex items-center gap-1 sm:gap-1.5 bg-white/[0.03] border border-white/[0.05] rounded-lg px-2.5 sm:px-3 py-1.5 sm:py-2" data-id="element-230">
                <span className="text-xs sm:text-sm" data-id="element-231">{badge.icon}</span>
                <span className="text-gray-300 text-[10px] sm:text-xs font-medium" data-id="element-232">
                  {badge.text}
                </span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}